import { contentHash } from "../../helpers";

type Props = {
    doc_id: number;
    page_id: number;
};
export function pageOrDocChanged(currentProps: Props, nextProps: Props) {
    let current_doc_id = currentProps.doc_id;
    let current_page_id = currentProps.page_id;

    let next_doc_id = nextProps.doc_id;
    let next_page_id = nextProps.page_id;

    return current_doc_id !== next_doc_id || current_page_id !== next_page_id;
}

export function getIds(props: Props) {
    return {
        doc_id: props.doc_id,
        page_id: props.page_id,
    };
}

export function compareHashWithContents(hash: string, contents: string) {
    return hash === contentHash(contents);
}
